import { z } from 'zod';

export const useLoginForm = () => {
    const schema = z
        .object({
            email: z.string().email(),
            password: z.string().min(1),
        });
    return {
        schema,
    };
};
